module.exports = __webpack_public_path__ + "img/look.e1e771b9.png";